import { getLoggerConfig } from './src/LoggerConfig';
import { WinstonLogger } from './src/WinstonLogger';
import { createWinstonLogger } from './src/createWinstonLogger';

const loggerConfig = getLoggerConfig();
const winston = createWinstonLogger(loggerConfig);
export const logger = new WinstonLogger(winston);
